import React, { useEffect, useState } from "react";
import "../styles/gptSidebar.scss";
// import PushupTracker from "./PushupTracker";
import { FaPause, FaPlay, FaQuestionCircle } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import PopupPrompt from "../reusable/PopupPrompt";
import { IoCloseSharp, IoInformationCircleOutline } from "react-icons/io5";
import study_music from "../audio/study_music.mp3";
import workout_music from "../audio/workout_music.mp3";
import runningAnimated from "../images/runningAnimated.gif";
import cyclingAnimated from "../images/cyclingAnimated.gif";
import exerciseAnimated from "../images/exerciseAnimated.gif";
import { validateExerciseCategory } from "../constants/constants";

const GptSidebar = ({ showExerciseBar }) => {
  const navigate = useNavigate();
  const [activity, setActivity] = useState("exercise");
  const [exerciseCategory, setExerciseCategory] = useState("");
  const [otherExercise, setOtherExercise] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("query");

  useEffect(() => {
    if (query) {
      setOtherExercise(true);
    }
  }, [query]);

  const handleActivity = (type) => {
    if (activity === type) {
      setActivity("");
      setExerciseCategory("");
    } else {
      setActivity(type);
    }
  };
  const handleExerciseCategory = (category) => {
    if (exerciseCategory === category) {
      setExerciseCategory("");
    } else {
      setExerciseCategory(validateExerciseCategory(category));
      navigate(`/exercise?type=${validateExerciseCategory(category)}`);
    }
  };


  const exerciseList = [
    { name: "Pushups", url: `/inetgpt/pushup-detail` },
    { name: "Squats", url: `/inetgpt/body-squat-detail` },
    { name: "Reverse Lunges", url: `/inetgpt/reverse-lunge-detail` },
    { name: "Lunge", url: `/inetgpt/reverse-lunge-detail` },
    { name: "Tricep dips", url: `/inetgpt/tricep-detail` },
    { name: "Mountain Climbers", url: `/inetgpt/mountain-detail` },
    { name: "Calf raises", url: `/inetgpt/calf-raise-detail` },
    { name: "Knee push-ups", url: `/inetgpt/knee-detail` },
    { name: "Crunch", url: `/inetgpt/crunch-detail` },
    { name: "Glute bridge", url: `/inetgpt/glute-detail` },
    { name: "Jumping jack", url: `/inetgpt/jumping-detail` },
    { name: "Leg raises", url: `/inetgpt/leg-detail` },
    { name: "Step-up", url: `/inetgpt/step-up-detail` },
    { name: "Bodyweight Squat", url: `/inetgpt/body-squat-detail` },
    { name: "Bicycle crunches", url: `/inetgpt/bicylce-detail` },
    { name: "Wall sit", url: `/inetgpt/wall-detail` },
    { name: "Arm Circles", url: `/inetgpt/arm-circle-detail` },
    { name: "Pull-ups", url: `/inetgpt/pullUps-detail` },
  ];

  const [studyMusicPlaying, setStudyMusicPlaying] = useState(false);
  const [studyMusic] = useState(new Audio(study_music));

  const [workoutMusicPlaying, setWorkoutMusicPlaying] = useState(false);
  const [workoutMusic] = useState(new Audio(workout_music));

  // START AND STOP STUDY MUSIC
  const handleStudyMusic = () => {
    if (studyMusicPlaying) {
      studyMusic.pause();
    } else if (workoutMusicPlaying) {
      workoutMusic.pause();
      setWorkoutMusicPlaying(false);
      studyMusic.play();
    } else {
      studyMusic.play();
    }
    setStudyMusicPlaying(!studyMusicPlaying);
  };

  useEffect(() => {
    return () => {
      studyMusic.pause();
      studyMusic.src = "";
    };
  }, [studyMusic]);

  // START AND STOP WORKOUT MUSIC
  const handleWorkoutMusic = () => {
    if (workoutMusicPlaying) {
      workoutMusic.pause();
    } else if (studyMusicPlaying) {
      studyMusic.pause();
      setStudyMusicPlaying(false);
      workoutMusic.play();
    } else {
      workoutMusic.play();
    }
    setWorkoutMusicPlaying(!workoutMusicPlaying);
  };

  useEffect(() => {
    return () => {
      workoutMusic.pause();
      workoutMusic.src = "";
    };
  }, [workoutMusic]);

  const handleOtherExercise = () => {
    setOtherExercise(false);
    setActivity("exercise");
    setExerciseCategory("");
  };

  const [exerciseData, setExerciseData] = useState([]);

  // Fetch stored exercise data from localStorage on mount
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("exerciseData")) || [];
    setExerciseData(data);
  }, []);

  // const handleNavigateHowtoUse = (itm) => {
  //   navigate("/know-more", {
  //     state: { url: itm },
  //   });
  // };

  return (
    <section className={`gpt_sidebar ${showExerciseBar ? "active" : ""}`}>
      <div className="top_bar">
        <ul>
          <li>
            <button
              onClick={() => handleActivity("training")}
              className={activity === "training" ? "active" : ""}
            >
              <img src={runningAnimated} alt="runningAnimated" />
            </button>
          </li>
          <li>
            <button
              onClick={() => handleActivity("cycling")}
              className={activity === "cycling" ? "active" : ""}
            >
              <img src={cyclingAnimated} alt="cyclingAnimated" />
            </button>
          </li>
          <li>
            <button
              title="Exercise"
              className={activity === "exercise" ? "active" : ""}
              onClick={() => handleActivity("exercise")}
              // disabled={activity === "exercise"}
            >
              <img src={exerciseAnimated} alt="exerciseAnimated" />
            </button>
          </li>
        </ul>

        {activity === "exercise" &&
          exerciseCategory === "" &&
          !otherExercise && (
            <div className="all_exercise_cat custonScroll">
              <div className="choose_title">Choose Any One:</div>
              {exerciseList.map((item, itemIndex) => (
                <div className="catgry" key={itemIndex}>
                  <button
                    title={item?.name}
                    className="exercise_category"
                    onClick={() => handleExerciseCategory(item?.name)}
                  >
                    {item?.name}
                  </button>
                  <button
                    title={`How to do ${item?.name}`}
                    className="know_more"
                    onClick={() => {
                      window.location.href = `${item?.url}`;
                    }}
                  >
                    <FaQuestionCircle />
                  </button>
                </div>
              ))}
            </div>
          )}

        {exerciseCategory !== "" && activity === "exercise" && (
          <div className="activity_tracker_camera_sec custonScroll">
            <ul className="activity_tracker">
              {exerciseData.length > 0 ? (
                exerciseData?.map((exercise, index) => {
                  const [exerciseName, count] = Object.entries(exercise)[0];
                  return (
                    <li key={index} className="exercise-item">
                      <p>
                        <strong>{exerciseName}</strong>: {count}{" "}
                      </p>

                      <p>
                        <span>Status</span>
                        {count > 10 ? (
                          <span className="status complete">Complete</span>
                        ) : (
                          <span className="status pending">Pending</span>
                        )}
                      </p>
                    </li>
                  );
                })
              ) : (
                <p>No exercises tracked yet.</p>
              )}
            </ul>

            {/* <PushupTracker
              exerciseStart={exerciseStart}
              setExerciseStart={setExerciseStart}
              setPushupCount={setPushupCount}
              setActivity={setActivity}
              setExerciseCategory={setExerciseCategory}
              setOtherExercise={setOtherExercise}
            /> */}
          </div>
        )}

        {otherExercise && (
          <div className="start_again">
            <button
              title="Continue With Other Exercise"
              onClick={() => handleOtherExercise()}
            >
              Continue With Other Exercise
            </button>
            <button title="Close" onClick={() => setOtherExercise(false)}>
              <IoCloseSharp /> Close
            </button>
          </div>
        )}

        {(activity === "training" || activity === "cycling") && (
          <div className="donwload_app_content">
            Unlock this feature by downloading our app! Get started today by
            downloading the{" "}
            <Link to="" target="_blank">
              Android App
            </Link>{" "}
            or{" "}
            <Link to="" target="_blank">
              iOS App
            </Link>{" "}
            and take your preparation to the next level!
          </div>
        )}
      </div>
      <div className="bottom_bar">
        <div className="music_list">
          <div>
            <h2>
              Binaural Music{" "}
              <span>
                <IoInformationCircleOutline />
              </span>
            </h2>
            <p
              className="binaural"
              onClick={() => {
                window.location.href = `/inetgpt/binural-music`;
              }}
            >
              Know, what is Binural Music?
            </p>
          </div>

          <ul>
            <li onClick={handleStudyMusic}>
              <p className="txt">For Study</p>
              <p onClick={handleStudyMusic}>
                {studyMusicPlaying ? <FaPause /> : <FaPlay />}
              </p>
            </li>
            <li onClick={handleWorkoutMusic}>
              <p className="txt">For Workout</p>
              <p onClick={handleWorkoutMusic}>
                {workoutMusicPlaying ? <FaPause /> : <FaPlay />}
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default GptSidebar;
